module.exports = __webpack_public_path__ + "static/media/fb_claro.cd1c9516.webp";